module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_miyazaki-a395a6196751752fa2607111420c57c4.png";